import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Rubro } from "app/models/rubro.models";
import { ParametrosService } from "app/services/parametros.service";
import { CreateRubroComponent } from "./create-rubro/create-rubro.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: "app-rubros",
  templateUrl: "./rubros.component.html",
  styleUrls: ["./rubros.component.css"],
})
export class RubrosComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  dataSource = new MatTableDataSource<Rubro>([]);
  loading = false;
  totalItems = 0;
  pageSize = 20;
  currentPage = 0;
  filteredData: Rubro[] = [];

  constructor(
    private parametrosService: ParametrosService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    const sidebar = <HTMLElement>document.querySelector(".navbar-brand");
    if (sidebar !== undefined) {
      sidebar.innerHTML = "Rubros";
    }
    this.getRubros();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.updatePagination();
  }

  updatePagination() {
    this.totalItems = this.dataSource.filteredData.length;
    if (this.paginator) {
      this.paginator.length = this.totalItems;
    }
  }

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
  }

   openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  getRubros() {
    this.loading = true;
    this.parametrosService.getRubros().subscribe(
      (data) => {
        this.dataSource.data = data;
        this.filteredData = data;
        this.totalItems = data.length;
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        console.error("Error al obtener los rubros", err);
        this.openSnackBar("Error al obtener los rubros", "Cerrar");
      }
    );
  }

   nuevoRubro() {
    let rubro: Rubro = new Rubro();
    const dialogRef = this.dialog.open(CreateRubroComponent, {
      disableClose: true,
      autoFocus: true,
      width: "400px",
      data: {
        name: '',
        code: '',
        type: "Nuevo",
      },
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (!data) return;
      const { code, name } = data;
      rubro.code = code;
      rubro.name = name;
      this.parametrosService.guardarRubro(rubro).subscribe(
          () => {
            this.openSnackBar("Rubro creado correctamente", "Cerrar");
            this.getRubros();
          },
          (error) => {
            console.error("Error al crear el rubro", error);
            this.openSnackBar("Error al crear el rubro", "Cerrar");
          }
        );
    });
  }

  editarRubro(rubro: Rubro) {
    const { id } = rubro;
    const dialogRef = this.dialog.open(CreateRubroComponent, {
      disableClose: true,
      autoFocus: true,
      width: "400px",
      data: {
        name: rubro.name,
        code: rubro.code,
        type: "Modificar",
      },
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (!data) return;
      const { code, name } = data;
      rubro.code = code;
      rubro.name = name;
      this.parametrosService.modificarRubro(rubro, id).subscribe(
          () => {
            this.openSnackBar("Rubro modificado correctamente", "Cerrar");
            this.getRubros();
          },
          (error) => {
            console.error("Error al modificar el rubro", error);
            this.openSnackBar("Error al modificar el rubro", "Cerrar");
          }
        );
    });
  }

  borrarRubro(rubro: Rubro) {
    const { id } = rubro;
    this.parametrosService.borrarRubro(id).subscribe(
      (data) => {
        this.openSnackBar("Rubro eliminado correctamente", "Cerrar");
        this.getRubros();
      },
      (error) => {
        console.error("Error al eliminar el rubro", error);
        this.openSnackBar("Error al eliminar el rubro", "Cerrar");
      }
    );
  }
}
